import { Field, useFormikContext } from 'formik'
import type { ReactElement } from 'react'
import cc from 'classcat'

import type { FormState } from './shared'
import { useThemeFilters } from './useThemeFilters'
import { useTranslate } from '../../../utils/translate'

export function ThemeFilters(): ReactElement {
  const { values } = useFormikContext<FormState>()
  const themeFilters = useThemeFilters(values.selectedTags)
  const t = useTranslate('interface', 'views.editorThemesView.filters')

  return (
    <div className="ep-theme-manager-theme-filters">
      {themeFilters.map((themeFilter) => (
        <fieldset className="ep-theme-manager-theme-filters-category" key={themeFilter.groupName}>
          <legend className="ep-theme-manager-theme-filters-category-name">
            {t(`categories.${themeFilter.groupName}`)}
          </legend>
          {themeFilter.filters.map((filter) => (
            <label
              className={cc(['ep-theme-manager-theme-filters-attribute', { disabled: filter.isDisabled }])}
              key={filter.id}
            >
              <Field type="checkbox" name="selectedTags" value={filter.id} disabled={filter.isDisabled} />
              <span>{t(`attributes.${filter.attribute}`)}</span>
            </label>
          ))}
        </fieldset>
      ))}
    </div>
  )
}
